import React from "react";
import { useTable } from "react-table";
import styled from "styled-components";
import { Customer } from "../../domain/customer/Customer";
import fireCustomerOpenEvent from "../../event/customerOpenEvent";
import OCContext from "../../OCContext";
import { ButtonSimple as SimpleButton } from "../form/button/Button";

const borderColor = "#ccc";

const Styles = styled.div`
  margin-top: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid ${borderColor};
    border-radius: 0.3rem;
    font-size: 0.9rem;

    tbody > tr:nth-child(odd) {
      background: #f2f2f2;
    }

    th {
      font-weight: bold;
    }

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      border-bottom: 1px solid ${borderColor};
      border-right: 1px solid ${borderColor};
      color: #333;
      letter-spacing: 0.03rem;
      margin: 0;
      padding: 0.5rem;
      text-align: left;
      white-space: nowrap;

      :last-child {
        border-right: 0;
      }
    }
  }
`;

const IconTickPanel = styled.div`
  height: 1.5rem;
  margin: auto;
  width: 1.5rem;
`;

const IconTable = styled.div`
  display: table;
`;

const IconTableCell = styled.div`
  display: table-cell;
  padding: 0.2rem;
  vertical-align: middle;
`;

const IconHourglassPanel = styled.div`
  height: 1.5rem;
  margin: auto;
  width: 1.5rem;

  & circle {
    fill: orange;
  }
  & path:nth-child(3) {
    fill: #fff;
  }

  & g {
    fill: #fff;
  }

  :hover {
    cursor: pointer;
  }
`;

const IconNegatePanel = styled.div`
  height: 1.5rem;
  margin: auto;
  width: 1.5rem;

  :hover {
    cursor: pointer;
  }

  svg circle {
    fill: #db0606;
  }

  svg path {
    fill: #fff;
  }
`;

const IconEmailPanel = styled.div`
  height: 1.5rem;
  margin: auto;
  width: 1.5rem;

  svg {
    fill: #1aa9ff;
    height: 100%;
    width: 100%;
  }

  :hover {
    cursor: pointer;
  }
`;

const Label = styled.label`
  color: #333;
`;

const LinkLabel = styled.label`
  border-bottom: 1px solid #333;
  color: #333;

  :hover {
    cursor: pointer;
  }
`;

const Table = ({ columns, data }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  });

  // Render the UI for your table
  return (
    <table {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

const getColumns = (setCustomer: (customer: Customer) => void) => {
  return [
    {
      Header: "Cust. ID",
      accessor: "customer_id"
    },
    {
      Header: "First Name",
      accessor: "name_first"
    },
    {
      Header: "Last Name",
      accessor: "name_last"
    },
    {
      Header: "Email",
      accessor: "email"
    },
    // {
    //   Header: "Login Access",
    //   id: "access",
    //   Cell: (data: any) => {
    //     switch (getLoginStatus(data)) {
    //       case "ACTIVE": {
    //         return (
    //           <IconTable>
    //             <IconTableCell>
    //               <IconTickPanel>
    //                 <IconTick />
    //               </IconTickPanel>
    //             </IconTableCell>
    //           </IconTable>
    //         );
    //       }
    //       case "PENDING": {
    //         return (
    //           <IconTable>
    //             <IconTableCell>
    //               <IconHourglassPanel>
    //                 <IconHourglass />
    //               </IconHourglassPanel>
    //             </IconTableCell>

    //             <IconTableCell>
    //               <LinkLabel onClick={() => window.alert("Re-invite sent")}>
    //                 Re-invite
    //               </LinkLabel>
    //             </IconTableCell>
    //           </IconTable>
    //         );
    //       }
    //       case "DECLINED": {
    //         return (
    //           <IconTable>
    //             <IconTableCell>
    //               <IconNegatePanel>
    //                 <IconNegate />
    //               </IconNegatePanel>
    //             </IconTableCell>

    //             <IconTableCell>
    //               <Label>
    //                 Declined
    //               </Label>
    //             </IconTableCell>
    //           </IconTable>
    //         );
    //       }
    //       case "NONE": {
    //         return (
    //           <IconTable>
    //             <IconTableCell>
    //               <IconEmailPanel>
    //                 <IconEmail />
    //               </IconEmailPanel>
    //             </IconTableCell>

    //             <IconTableCell>
    //               <LinkLabel onClick={() => window.alert("Invite sent.")}>
    //                 Invite
    //               </LinkLabel>
    //             </IconTableCell>
    //           </IconTable>
    //         );
    //       }
    //     }
    //   },
    // },
    {
      Cell: (data: any) => (
        <SimpleButton onClick={() => setCustomer(data.row.original)}>OPEN</SimpleButton>
      ),
      id: "open",
    },
  ];
};

const T = ({ customers }: { customers: Customer[] }) => {
  const { setCustomer } = React.useContext(OCContext);

  const openCustomer = (customer: Customer) => {
    setCustomer(customer);
    fireCustomerOpenEvent(customer);
  }

  return customers && customers.length > 0 ? (
    <Styles>
      <Table columns={getColumns(openCustomer)} data={customers} />
    </Styles>
  ) : null;
};

export default T;
